export const allDayOfferType: number = 2; // event_type for the offer
